# Поиск по сайту
class window.Search
  constructor: ->
    @popupPageOpen = false # флаг, показывающий, что окно с поиском открыто
    @scroll_top = 0 # размер прокрутки контента
    @searchBlock = $('.search-wrapper') # всплывающие окно с поиском
    @searchCloseButton = $('.search-close-block') # кнопка закрытия поиска
    @searchLink = $('.gosbar__search') # кнопка открытия поиска
    @searchDropdownInput = $('.search-block .search-input') # инпут с поиском
    @searchDropdownItemLink = $('.block-dropdown-link') # ссылка в результате поиска
    @searchDropdownBlock = $('.search-block-dropdown') # блок с выпадающем результатом поиска
    @searchButton = $('.base-search-button') # кнопка поиска

    @initSearchOpen()
    @initSearchClose()
    @initSearchDropdownOpen()
    @writeSearchWordInStatic()

  delay = do ->
    timer = 0
    (callback, ms) ->
      clearTimeout timer
      timer = setTimeout(callback, ms)
      return

  # закрытие окна с поиском
  initSearchClose: ->
    self = this
    @searchCloseButton.click ->
      self.closeSearch()

# инициализация появления выпадающего списка с результатами поиска
  initSearchDropdownOpen: ->
    self = this
    @searchDropdownInput.keyup ->
      if ($.trim(self.searchDropdownInput.val()).length > 2)
        self.searchButton.prop('disabled', false)
        delay (->
          self.SearchAjaxExec();
          return
        ), 500
      else
        self.searchButton.prop('disabled', true)
        self.searchDropdownBlock.hide()

    @searchDropdownInput.click ->
      self.SearchDropdownOpen()

    self.searchBlock.click (event) ->
      if $(event.target).closest(self.searchDropdownInput).length
        return
      self.searchDropdownBlock.hide()


    @searchDropdownItemLink.click ->
      self.searchDropdownInput.val($(this).text())
      $('.search-block-dropdown').hide()
      return false

  SearchAjaxExec: ->
    self = this
    resultList = ''
    $.ajax
      url: '/controllers/ako_ajax_search.php' # Путь до скрипта поиска
      data: {'searchString': $.trim(@searchDropdownInput.val())}
      type: 'post'
      dataType: 'json'
      success: (result) ->
        $.each result, (key, value) ->
          resultList += '<div class="block-dropdown-label">' + key + '</div>'
          resultList += '<div class="block-dropdown-result">'
          $.each value, (key, value) ->
            resultList += '<a href="' + value.DETAIL_PAGE_URL + '" class="block-dropdown-link" data-result-id="" data-type-block="' + value.TYPE_BLOCK + '">' + value.NAME + '</a>'
            return
          resultList += '</div>'
        self.searchDropdownBlock.html(resultList) # Заполняем блок результатами
        self.writeSearchWordInAjax()
        self.SearchDropdownOpen()
        return

  SearchDropdownOpen: ->
    if screen.width < 767
      return
    self = this
    if (self.searchDropdownInput.val().length > 0)
      self.searchButton.prop('disabled', false)
      self.searchDropdownBlock.show()
    else
      self.searchButton.prop('disabled', true)
      self.searchDropdownBlock.hide()

# Открытие/закрытие всплывающего окна с поиском
  initSearchOpen: ->
    self = this
    @searchLink.click ->
      unless self.popupPageOpen
        self.openSearch()
      else
        self.closeSearch()



# манипуляции при открытии всплывающего окна, чтобы страница не прыгала
  editSearchPosition: ->
    self = this
    if $(window).scrollTop() || $('.popup-overlay').scrollTop() > 56
      self.searchBlock.removeClass('search-wrapper--position-2')
      self.searchBlock.addClass('search-wrapper--position-1')
    else
      self.searchBlock.removeClass('search-wrapper--position-1')
      self.searchBlock.addClass('search-wrapper--position-2')


  openSearch: ->
    self = this
    self.popupPageOpen = true

    unless window.currentScrollSetFlag
      window.currentScroll = window.pageYOffset
      window.currentScrollSetFlag = true

    window.headerObject.siteMapClose()
    # закрытие всплывающего окна с каталогом сайтов
    if window.headerObject.sitesListPageOpen
      window.newspopupObject.closePopup()
      window.headerObject.sitesListPageOpen = false

    self.editSearchPosition()
    $('body').addClass('body-overflow')

    setTimeout(
      ->
        $('.b-page').addClass('b-page--hidden')
        $('.gosbar').addClass('gosbar--hidden')
    , 100)

    self.searchLink.addClass('active')
    self.searchBlock.slideDown()
    self.toggleSearch()


  closeSearch: ->
    self = this
    self.popupPageOpen = false
    self.editSearchPosition()
    $('body').removeClass('body-overflow')
    $('.b-page').removeClass('b-page--hidden')
    $('.gosbar').removeClass('gosbar--hidden')

    self.searchLink.removeClass('active')
    self.searchBlock.slideUp()
    self.toggleSearch()

    if window.currentScrollSetFlag
      $(window).scrollTop(window.currentScroll)

    if self.popupPageOpen == false && window.headerObject.popupPageOpen == false
      window.currentScroll = 0
      window.currentScrollSetFlag = false


  toggleSearch: ->
    self = this

    setTimeout(
      ->
        self.searchBlock.scrollTop(0)
    , 400)

    if window.innerWidth > 720
      self.searchDropdownInput.focus()


  #фиксация клика по статическому элементу выдачи для статистики популярных запросов
  writeSearchWordInStatic: ->
    $('a.search-page__result-item').click (event) ->
      event.preventDefault()
      title         =   $($(this).children('h4.preview-small__title')[0]).text().trim()
      description   =   $($(this).children('.preview-small__description')[0]).text().trim()
      typeBlock     =   $(this).data('typeBlock')
      href          =   $(this).attr('href')
      if typeBlock == ''
        typeBlock = 'static'

      if description == ''
        description = 'empty'

      request = $.ajax
        url: '/controllers/ako_ajax_search_word_write.php' # Путь до скрипта записьи найденного документа
        data: {'href': href, 'title': title, 'description': description, 'typeblock': typeBlock}
        type: 'post'
        dataType: 'json'
        success: (result) ->
          return

      window.location.replace(href)

#  writeSearchWordInStatic: (self) ->
#      title = $($(this).children('h4.preview-small__title')[0]).text().trim()
#      description = $($(this).children('.preview-small__description')[0]).text().trim()
#      if description == ''
#        description = 'empty'
#      href = $(self).attr('href')
#
#      return ['href': href, 'title': title, 'description': description]
##
  writeSearchWordInAjax: ->
    $('.block-dropdown-link').click (event) ->
      event.preventDefault()

      href        = $(this).attr('href').trim()
      title       = $(this).text().trim()
      typeBlock   = $(this).data('typeBlock')

      if typeBlock == 'undefined'
        typeBlock = 'static'


      data = {
        'href': href,
        'title': title,
        'description': 'empty',
        'typeblock': typeBlock
      }

      request = $.ajax
        url: '/controllers/ako_ajax_search_word_write.php' # Путь до скрипта записьи найденного документа
        data: data
        type: 'post'
        dataType: 'json'
        success: (result) ->
          return

      window.location.replace(href)



// WEBPACK FOOTER //
// ./assets/javascripts/app/search.coffee